/** Idiomas da interface: a lista vem do common (o backend usa a mesma para o idioma do link). */
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, LOCALE_HEADER, LOCALE_QUERY_PARAM, isSupportedLocale } from '@common/constants/locale';

export { DEFAULT_LOCALE, SUPPORTED_LOCALES, LOCALE_HEADER, LOCALE_QUERY_PARAM };

export const LOCALE_STORAGE_KEY = 'tc-locale';

/** Idioma do Vuetify (textos internos de tabela, paginação, datas) para cada idioma da interface. */
export const VUETIFY_LOCALE_MAP = {
  'pt-BR': 'pt',
  es: 'es',
  en: 'en',
  'pt-PT': 'pt'
};

/** Qualquer valor fora da lista vira o padrão: o localStorage pode ter sido editado à mão. */
export function resolveLocale(value) {
  return isSupportedLocale(value) ? value : DEFAULT_LOCALE;
}

/** Idioma que veio no link (?lang=es): é o de quem gerou o link para o cliente. */
export function readUrlLocale() {
  try {
    const value = new URLSearchParams(window.location.search).get(LOCALE_QUERY_PARAM);

    return isSupportedLocale(value) ? value : null;
  } catch (error) {
    return null;
  }
}

/** Escolha no seletor vence o link: tira o ?lang do endereço para o F5 não voltar ao idioma do link. */
export function clearUrlLocale() {
  try {
    const url = new URL(window.location.href);

    if (!url.searchParams.has(LOCALE_QUERY_PARAM)) return;

    url.searchParams.delete(LOCALE_QUERY_PARAM);
    window.history.replaceState(window.history.state, '', url.toString());
  } catch (error) {
    // Sem history (ambiente de teste antigo): o idioma escolhido continua salvo
  }
}

/** O idioma do link vence o salvo e passa a ser o salvo: o cliente segue nele ao navegar e no F5. */
export function readStoredLocale() {
  const urlLocale = readUrlLocale();

  if (urlLocale) {
    storeLocale(urlLocale);

    return urlLocale;
  }

  try {
    return resolveLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch (error) {
    return DEFAULT_LOCALE;
  }
}

/** <html lang> acompanha a interface: leitores de tela e o botão do Google leem daqui. */
export function applyDocumentLocale(locale) {
  if (typeof document !== 'undefined') document.documentElement.lang = resolveLocale(locale);
}

export function storeLocale(locale) {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (error) {
    // Navegador sem armazenamento (aba anônima, bloqueio): o idioma vale só nesta sessão
  }
}
